import { useState } from 'react';

const faqs = [
  {
    question: '福利视频大全是什么类型的网站？',
    answer: '福利视频大全是一个精选视频资源聚合平台，致力于为用户提供高质量、多类型的福利视频内容。我们涵盖影视花絮、综艺娱乐、音乐舞台、体育赛事、动漫二次元、游戏电竞、生活时尚等多个领域，所有内容均可免费在线观看，每日持续更新。',
  },
  {
    question: '网站上的视频需要付费观看吗？',
    answer: '完全不需要！福利视频大全上所有的视频资源都是免费观看的。我们致力于为广大用户提供优质的免费视频内容，无需注册会员，无需付费订阅，直接打开就能看，没有任何隐藏收费。',
  },
  {
    question: '视频内容多久更新一次？',
    answer: '我们保持每日更新的节奏，每天都会有新的精选福利视频上线。无论是热门影视的幕后花絮，还是最新综艺的搞笑片段，亦或是刚刚结束的精彩赛事集锦，你都能在第一时间在我们的网站上找到。建议收藏本站并经常回来看看，精彩内容不容错过！',
  },
  {
    question: '如何快速找到我感兴趣的视频？',
    answer: '我们有多种方式帮助你快速找到感兴趣的内容。你可以通过顶部的导航栏直接进入分类页面，也可以在首页使用分类标签进行筛选。此外，每个分类都有独立的页面，方便你按类别浏览所有相关视频。如果特别喜欢某个类型的视频，记得收藏对应的分类页面。',
  },
  {
    question: '网站支持手机端浏览吗？',
    answer: '支持的！福利视频大全采用响应式设计，完美适配电脑、平板和手机等各类设备。无论你是在家使用电脑，还是出门在外用手机，都能获得流畅舒适的浏览体验。手机端界面简洁清晰，操作便捷。',
  },
  {
    question: '视频播放不流畅怎么办？',
    answer: '如果遇到视频播放卡顿的情况，可以尝试以下方法：1）检查你的网络连接是否稳定；2）尝试降低视频清晰度；3）关闭其他占用带宽的应用程序；4）尝试切换到不同的网络环境。如果问题持续存在，欢迎通过关于我们页面的联系方式反馈，我们会及时优化。',
  },
  {
    question: '我可以下载网站上的视频吗？',
    answer: '福利视频大全是一个在线视频观看平台，目前暂不提供视频下载功能。我们建议你通过收藏本网站或分享链接的方式来保存喜欢的视频，方便随时回来观看。所有视频资源都会长期保留在网站上，不用担心内容丢失。',
  },
  {
    question: '如何向我们反馈建议或问题？',
    answer: '我们非常欢迎你的反馈和建议！你可以通过关于我们页面提供的联系方式与我们取得联系，也可以发送邮件到 contact@fulivideo.com。无论是内容建议、功能需求还是使用问题，我们都会认真对待并及时处理。你的反馈是我们进步的动力！',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于福利视频大全，你可能想知道的事情
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-colors ${
                  openIndex === index
                    ? 'bg-primary-100 text-primary-500'
                    : 'bg-background-200 text-foreground-400'
                }`}>
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-sm`}></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4 animate-fade-in">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}